var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.useContainerView) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "position": "relative"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dettaglioOrdineLbl))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.idLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.idValue),
      callback: function($$v) {
        _vm.idValue = $$v
      },
      expression: "idValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idValue),
      expression: "idValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "idValueId"
    },
    domProps: {
      "value": (_vm.idValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.tipoOrdine",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.tipoOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.tipoOrdineValue),
      callback: function($$v) {
        _vm.tipoOrdineValue = $$v
      },
      expression: "tipoOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoOrdineValue),
      expression: "tipoOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "tipoOrdineValueId"
    },
    domProps: {
      "value": (_vm.tipoOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoOrdineValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.statoOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.statoOrdineValue),
      callback: function($$v) {
        _vm.statoOrdineValue = $$v
      },
      expression: "statoOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statoOrdineValue),
      expression: "statoOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "statoOrdineValueId"
    },
    domProps: {
      "value": (_vm.statoOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.statoOrdineValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.changeStatusEnable) ? _c('div', {
    staticClass: "controls col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100px",
      "padding": "3px",
      "float": "right"
    },
    attrs: {
      "id": "changeStatusBtnId",
      "disabled": _vm.changeStatusNotClickable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeStatusClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.changeStatusBtnLabel))])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.numOrdCli",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.numOrdineCliLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.numOrdineCliValue),
      callback: function($$v) {
        _vm.numOrdineCliValue = $$v
      },
      expression: "numOrdineCliValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numOrdineCliValue),
      expression: "numOrdineCliValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "numOrdineCliValueId"
    },
    domProps: {
      "value": (_vm.numOrdineCliValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numOrdineCliValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.scontoBase",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices && _vm.showScontoBase) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.scontoBaseLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.scontoBaseValue),
      callback: function($$v) {
        _vm.scontoBaseValue = $$v
      },
      expression: "scontoBaseValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scontoBaseValue),
      expression: "scontoBaseValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "scontoBaseValueId"
    },
    domProps: {
      "value": (_vm.scontoBaseValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scontoBaseValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1), _vm._v(" "), (_vm.document) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.documentiLbL))])]), _vm._v(" "), _c('input-w', [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": _vm.document.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.document.name))])])])])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.clienteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.clienteValue),
      callback: function($$v) {
        _vm.clienteValue = $$v
      },
      expression: "clienteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clienteValue),
      expression: "clienteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "clienteValueId"
    },
    domProps: {
      "value": (_vm.clienteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clienteValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.utenteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.utenteValue),
      callback: function($$v) {
        _vm.utenteValue = $$v
      },
      expression: "utenteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utenteValue),
      expression: "utenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "utenteValueId"
    },
    domProps: {
      "value": (_vm.utenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utenteValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart3.portType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.portoLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.portoValue),
      callback: function($$v) {
        _vm.portoValue = $$v
      },
      expression: "portoValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portoValue),
      expression: "portoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "portoValueId"
    },
    domProps: {
      "value": (_vm.portoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.portoValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.dataOrdine",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataOrdineValue),
      callback: function($$v) {
        _vm.dataOrdineValue = $$v
      },
      expression: "dataOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataOrdineValue),
      expression: "dataOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataOrdineValueId"
    },
    domProps: {
      "value": (_vm.dataOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataOrdineValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart3.shippingType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.tipoSpedizioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.tipoSpedizioneValue),
      callback: function($$v) {
        _vm.tipoSpedizioneValue = $$v
      },
      expression: "tipoSpedizioneValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoSpedizioneValue),
      expression: "tipoSpedizioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "tipoSpedizioneId"
    },
    domProps: {
      "value": (_vm.tipoSpedizioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoSpedizioneValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.destinatarioIndirizzo",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.destinatarioLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.destinatarioValue),
      callback: function($$v) {
        _vm.destinatarioValue = $$v
      },
      expression: "destinatarioValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destinatarioValue),
      expression: "destinatarioValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "destinatarioId"
    },
    domProps: {
      "value": (_vm.destinatarioValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destinatarioValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart3.reqDeliveryDate",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataConsRichiestaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataConsRichiestaValue),
      callback: function($$v) {
        _vm.dataConsRichiestaValue = $$v
      },
      expression: "dataConsRichiestaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataConsRichiestaValue),
      expression: "dataConsRichiestaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataConsRichiestaId"
    },
    domProps: {
      "value": (_vm.dataConsRichiestaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataConsRichiestaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.valutaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.valutaValue),
      callback: function($$v) {
        _vm.valutaValue = $$v
      },
      expression: "valutaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valutaValue),
      expression: "valutaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "valutaId"
    },
    domProps: {
      "value": (_vm.valutaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valutaValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.indirizzoLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.indirizzoValue),
      callback: function($$v) {
        _vm.indirizzoValue = $$v
      },
      expression: "indirizzoValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoValue),
      expression: "indirizzoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "indirizzoId"
    },
    domProps: {
      "value": (_vm.indirizzoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.dataConferma",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataConfermaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataConfermaValue),
      callback: function($$v) {
        _vm.dataConfermaValue = $$v
      },
      expression: "dataConfermaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataConfermaValue),
      expression: "dataConfermaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataConfermaId"
    },
    domProps: {
      "value": (_vm.dataConfermaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataConfermaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.totOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.totOrdineValue),
      callback: function($$v) {
        _vm.totOrdineValue = $$v
      },
      expression: "totOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totOrdineValue),
      expression: "totOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "totOrdineId"
    },
    domProps: {
      "value": (_vm.totOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totOrdineValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.localitaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.localitaValue),
      callback: function($$v) {
        _vm.localitaValue = $$v
      },
      expression: "localitaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaValue),
      expression: "localitaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "localitaId"
    },
    domProps: {
      "value": (_vm.localitaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.note",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.noteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.noteValue),
      callback: function($$v) {
        _vm.noteValue = $$v
      },
      expression: "noteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteValue),
      expression: "noteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "noteId"
    },
    domProps: {
      "value": (_vm.noteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.capLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.capValue),
      callback: function($$v) {
        _vm.capValue = $$v
      },
      expression: "capValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capValue),
      expression: "capValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "capId"
    },
    domProps: {
      "value": (_vm.capValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.regioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.regioneValue),
      callback: function($$v) {
        _vm.regioneValue = $$v
      },
      expression: "regioneValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regioneValue),
      expression: "regioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "regioneId"
    },
    domProps: {
      "value": (_vm.regioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regioneValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.noteGestore",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.noteGestLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.noteGestValue),
      callback: function($$v) {
        _vm.noteGestValue = $$v
      },
      expression: "noteGestValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteGestValue),
      expression: "noteGestValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "noteGestId"
    },
    domProps: {
      "value": (_vm.noteGestValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteGestValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.provinciaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.provinciaValue),
      callback: function($$v) {
        _vm.provinciaValue = $$v
      },
      expression: "provinciaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaValue),
      expression: "provinciaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "provinciaId"
    },
    domProps: {
      "value": (_vm.provinciaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.nazioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.nazioneValue),
      callback: function($$v) {
        _vm.nazioneValue = $$v
      },
      expression: "nazioneValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneValue),
      expression: "nazioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nazioneId"
    },
    domProps: {
      "value": (_vm.nazioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "columns": _vm.gridProdAttributesCfg.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "others": _vm.others,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.gridProdAttributesCfg.title
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "controls col-sm-1",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back')))])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.printPreviewBtn",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.orderSynced
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$root.printOrder(_vm.idValue)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('print preview')))])])])], 1), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), (this.sendingCart) ? _c('div', {
    staticStyle: {
      "opacity": "1",
      "background": "rgba(255, 255, 255, 0.65)",
      "z-index": "9999",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100vw",
      "height": "100vh",
      "transition": "opacity 0.3s",
      "transform": "translate3D(0, 0, 0)"
    }
  }, [_vm._m(4)]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "margin": "10px",
      "position": "relative"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dettaglioOrdineLbl))])])]), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12  col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.statoOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.statoOrdineValue),
      callback: function($$v) {
        _vm.statoOrdineValue = $$v
      },
      expression: "statoOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statoOrdineValue),
      expression: "statoOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "statoOrdineValueId"
    },
    domProps: {
      "value": (_vm.statoOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.statoOrdineValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.changeStatusEnable) ? _c('div', {
    staticClass: "controls col-xs-4 col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100px",
      "padding": "3px",
      "float": "right"
    },
    attrs: {
      "id": "changeStatusBtnId",
      "disabled": _vm.changeStatusNotClickable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeStatusClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.changeStatusBtnLabel))])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row  no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12  col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.idLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.idValue),
      callback: function($$v) {
        _vm.idValue = $$v
      },
      expression: "idValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8  col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idValue),
      expression: "idValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "idValueId"
    },
    domProps: {
      "value": (_vm.idValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.tipoOrdine",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4  col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.tipoOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.tipoOrdineValue),
      callback: function($$v) {
        _vm.tipoOrdineValue = $$v
      },
      expression: "tipoOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoOrdineValue),
      expression: "tipoOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "tipoOrdineValueId"
    },
    domProps: {
      "value": (_vm.tipoOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoOrdineValue = $event.target.value
      }
    }
  })])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.numOrdCli",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.numOrdineCliLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.numOrdineCliValue),
      callback: function($$v) {
        _vm.numOrdineCliValue = $$v
      },
      expression: "numOrdineCliValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numOrdineCliValue),
      expression: "numOrdineCliValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "numOrdineCliValueId"
    },
    domProps: {
      "value": (_vm.numOrdineCliValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numOrdineCliValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.scontoBase",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices && _vm.showScontoBase) ? _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.scontoBaseLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.scontoBaseValue),
      callback: function($$v) {
        _vm.scontoBaseValue = $$v
      },
      expression: "scontoBaseValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scontoBaseValue),
      expression: "scontoBaseValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "scontoBaseValueId"
    },
    domProps: {
      "value": (_vm.scontoBaseValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scontoBaseValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.clienteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.clienteValue),
      callback: function($$v) {
        _vm.clienteValue = $$v
      },
      expression: "clienteValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clienteValue),
      expression: "clienteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "clienteValueId"
    },
    domProps: {
      "value": (_vm.clienteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clienteValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.utenteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.utenteValue),
      callback: function($$v) {
        _vm.utenteValue = $$v
      },
      expression: "utenteValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utenteValue),
      expression: "utenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "utenteValueId"
    },
    domProps: {
      "value": (_vm.utenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.utenteValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataOrdineValue),
      callback: function($$v) {
        _vm.dataOrdineValue = $$v
      },
      expression: "dataOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataOrdineValue),
      expression: "dataOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataOrdineValueId"
    },
    domProps: {
      "value": (_vm.dataOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataOrdineValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart3.shippingType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.tipoSpedizioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.tipoSpedizioneValue),
      callback: function($$v) {
        _vm.tipoSpedizioneValue = $$v
      },
      expression: "tipoSpedizioneValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoSpedizioneValue),
      expression: "tipoSpedizioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "tipoSpedizioneId"
    },
    domProps: {
      "value": (_vm.tipoSpedizioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoSpedizioneValue = $event.target.value
      }
    }
  })])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart3.reqDeliveryDate",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataConsRichiestaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataConsRichiestaValue),
      callback: function($$v) {
        _vm.dataConsRichiestaValue = $$v
      },
      expression: "dataConsRichiestaValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataConsRichiestaValue),
      expression: "dataConsRichiestaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataConsRichiestaId"
    },
    domProps: {
      "value": (_vm.dataConsRichiestaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataConsRichiestaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.valutaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.valutaValue),
      callback: function($$v) {
        _vm.valutaValue = $$v
      },
      expression: "valutaValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valutaValue),
      expression: "valutaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "valutaId"
    },
    domProps: {
      "value": (_vm.valutaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valutaValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.dataConferma",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.dataConfermaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.dataConfermaValue),
      callback: function($$v) {
        _vm.dataConfermaValue = $$v
      },
      expression: "dataConfermaValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataConfermaValue),
      expression: "dataConfermaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "dataConfermaId"
    },
    domProps: {
      "value": (_vm.dataConfermaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataConfermaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.totOrdineLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.totOrdineValue),
      callback: function($$v) {
        _vm.totOrdineValue = $$v
      },
      expression: "totOrdineValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totOrdineValue),
      expression: "totOrdineValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "totOrdineId"
    },
    domProps: {
      "value": (_vm.totOrdineValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totOrdineValue = $event.target.value
      }
    }
  })])])], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.note",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.noteLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.noteValue),
      callback: function($$v) {
        _vm.noteValue = $$v
      },
      expression: "noteValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteValue),
      expression: "noteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "noteId"
    },
    domProps: {
      "value": (_vm.noteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteValue = $event.target.value
      }
    }
  })])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.noteGestore",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.noteGestLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.noteGestValue),
      callback: function($$v) {
        _vm.noteGestValue = $$v
      },
      expression: "noteGestValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteGestValue),
      expression: "noteGestValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "noteGestId"
    },
    domProps: {
      "value": (_vm.noteGestValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteGestValue = $event.target.value
      }
    }
  })])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart3.portType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.portoLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.portoValue),
      callback: function($$v) {
        _vm.portoValue = $$v
      },
      expression: "portoValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portoValue),
      expression: "portoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "portoValueId"
    },
    domProps: {
      "value": (_vm.portoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.portoValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.destinatarioIndirizzo",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.destinatarioLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.destinatarioValue),
      callback: function($$v) {
        _vm.destinatarioValue = $$v
      },
      expression: "destinatarioValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destinatarioValue),
      expression: "destinatarioValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "destinatarioId"
    },
    domProps: {
      "value": (_vm.destinatarioValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destinatarioValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.indirizzoLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.indirizzoValue),
      callback: function($$v) {
        _vm.indirizzoValue = $$v
      },
      expression: "indirizzoValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoValue),
      expression: "indirizzoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "indirizzoId"
    },
    domProps: {
      "value": (_vm.indirizzoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-2 col-sm-2",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.localitaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.localitaValue),
      callback: function($$v) {
        _vm.localitaValue = $$v
      },
      expression: "localitaValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-10 padLeft10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaValue),
      expression: "localitaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "localitaId"
    },
    domProps: {
      "value": (_vm.localitaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.capLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.capValue),
      callback: function($$v) {
        _vm.capValue = $$v
      },
      expression: "capValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capValue),
      expression: "capValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "capId"
    },
    domProps: {
      "value": (_vm.capValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.regioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.regioneValue),
      callback: function($$v) {
        _vm.regioneValue = $$v
      },
      expression: "regioneValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regioneValue),
      expression: "regioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "regioneId"
    },
    domProps: {
      "value": (_vm.regioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regioneValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.provinciaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.provinciaValue),
      callback: function($$v) {
        _vm.provinciaValue = $$v
      },
      expression: "provinciaValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaValue),
      expression: "provinciaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "provinciaId"
    },
    domProps: {
      "value": (_vm.provinciaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-4 col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.orderDetailLabels.nazioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.orderDetailLabels
    },
    model: {
      value: (_vm.nazioneValue),
      callback: function($$v) {
        _vm.nazioneValue = $$v
      },
      expression: "nazioneValue"
    }
  }, [_c('div', {
    staticClass: "col-xs-8 col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneValue),
      expression: "nazioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nazioneId"
    },
    domProps: {
      "value": (_vm.nazioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneValue = $event.target.value
      }
    }
  })])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "columns": _vm.gridProdAttributesCfg.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "others": _vm.others,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.gridProdAttributesCfg.title
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), (this.sendingCart) ? _c('div', {
    staticStyle: {
      "opacity": "1",
      "background": "rgba(255, 255, 255, 0.65)",
      "z-index": "9999",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100vw",
      "height": "100vh",
      "transition": "opacity 0.3s",
      "transform": "translate3D(0, 0, 0)"
    }
  }, [_vm._m(8)]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                 \n                            ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e1f036","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/OrderDetail.vue
// module id = 1727
// module chunks = 1